/* ty-tel-copy (30.09.2026)
 * לחיצה על מספר טלפון: בטלפון מתקשרת (ברירת המחדל של הדפדפן), במחשב מעתיקה.
 * «מחשב» = עכבר, ולא רוחב מסך. אייפד הוא מגע ולכן מתקשר.
 * הכלי: shopify-agent/scripts/apply-tel-copy-desktop-2026-09-30.mjs */
(function () {
  if (window.__tyTelCopy) return;
  window.__tyTelCopy = true;

  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var HINT = 'לחיצה מעתיקה את המספר';

  function pretty(d) {
    if (/^0[5-9]\d{8}$/.test(d)) return d.slice(0, 3) + '-' + d.slice(3);
    if (/^0\d{8}$/.test(d)) return d.slice(0, 2) + '-' + d.slice(2);
    return d;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, legacy);
    }
    return Promise.resolve(legacy());
    function legacy() {
      try {
        var t = document.createElement('textarea');
        t.value = text;
        t.setAttribute('readonly', '');
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        var ok = document.execCommand('copy');
        t.remove();
        return ok;
      } catch (e) { return false; }
    }
  }

  var toast, timer;
  function show(ok, num) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ty-telcopy';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = '';
    var lead = document.createElement('span');
    lead.textContent = ok ? 'המספר הועתק: ' : 'המספר: ';
    var n = document.createElement('span');
    n.className = 'ty-telcopy__num';
    n.dir = 'ltr';
    n.textContent = num;
    toast.appendChild(lead);
    toast.appendChild(n);
    toast.setAttribute('data-on', '1');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.setAttribute('data-on', '0'); }, 2600);
  }

  document.addEventListener('click', function (e) {
    if (!mouse.matches || e.defaultPrevented || e.button !== 0) return;
    var a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (!a) return;
    var digits = decodeURIComponent(a.getAttribute('href').slice(4)).replace(/[^\d+]/g, '');
    if (!digits) return;
    e.preventDefault();
    var num = pretty(digits);
    copy(num).then(function (ok) { show(ok, num); });
  }, true);

  document.addEventListener('pointerover', function (e) {
    if (!mouse.matches) return;
    var a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (a && !a.hasAttribute('title')) a.setAttribute('title', HINT);
  }, { passive: true });
})();
